export default __webpack_public_path__ + "images/Pickup_Instruction.svg";